/* PDP only (loaded by sections/main-product.liquid) */
/* PDP gallery: open images and videos in Fancybox instead of the theme's media modal */
document.addEventListener(
  'click',
  function (event) {
    if (!document.body.classList.contains('product') || typeof Fancybox === 'undefined') return;

    // The click usually lands on the <img> (magnify.js listens there) or on the playing <video>, not on the toggle button.
    var container = event.target.closest('.product-media-container');
    var trigger = container && container.querySelector('.product__media-toggle[data-fancybox-src]');
    if (!trigger || trigger.closest('quick-add-modal')) return;

    var wrapper = trigger.closest('.product__media-wrapper');
    if (!wrapper) return;

    var buttons = Array.prototype.filter.call(
      wrapper.querySelectorAll('.product__media-toggle[data-fancybox-src]'),
      function (button) {
        var item = button.closest('.product__media-item');
        // the pictures of the other pages of the grid (hidden only by the six-at-a-time paging) are part of the lightbox too
        return !item || item.offsetParent !== null || item.classList.contains('pdp-page-hidden');
      }
    );
    var startIndex = buttons.indexOf(trigger);
    if (startIndex < 0) return;

    event.preventDefault();
    event.stopPropagation();

    Fancybox.show(
      buttons.map(function (button) {
        var src = button.getAttribute('data-fancybox-src');
        var poster = button.getAttribute('data-fancybox-poster') || undefined;
        return {
          src: src,
          type: button.getAttribute('data-fancybox-type') || 'image',
          poster: poster,
          // the strip of small pictures under the big one: a small version of each picture (the big one is 2400px wide)
          thumbSrc: poster || (src ? src.replace(/([?&])width=\d+/, '$1width=240') : undefined),
          caption: button.getAttribute('data-fancybox-caption') || '',
        };
      }),
      {
        startIndex: startIndex,
        // xlfeet-style lightbox: loop, click image to zoom (max 200%), click outside to close
        Carousel: { infinite: true },
        // the photo gallery (strip of small pictures) is under the big picture from the start; the grid button of the toolbar hides / shows it
        Thumbs: { type: 'classic', showOnStart: true },
        Images: { Panzoom: { maxScale: 2 } },
        contentClick: 'toggleZoom',
        // mouse wheel moves to the next / previous image (instead of zooming)
        wheel: 'slide',
        backdropClick: 'close',
        Toolbar: {
          display: {
            left: ['infobar'],
            middle: [],
            right: ['toggle1to1', 'slideshow', 'fullscreen', 'thumbs', 'close'],
          },
        },
        on: {
          // the gallery behind goes to the picture the lightbox was closed on (its page on a desktop, its slide on a phone)
          close: function (fancybox) {
            var slide = fancybox.getSlide && fancybox.getSlide();
            if (slide) document.dispatchEvent(new CustomEvent('pdp:lightbox-closed', { detail: { index: slide.index } }));
          },
          ready: function (fancybox) {
            pdpFancyboxZoomControls(fancybox);
          },
          destroy: function () {
            if (window.__pdpZoomTimer) clearInterval(window.__pdpZoomTimer);
            window.__pdpZoomTimer = null;
          },
        },
      }
    );
  },
  true
);

/* xlfeet-style zoom pill (- 100% +) shown at the top centre of the PDP Fancybox */
function pdpFancyboxZoomControls(fancybox) {
  var container = fancybox.container;
  if (!container || container.querySelector('.pdp-fb-zoom')) return;

  var pill = document.createElement('div');
  pill.className = 'pdp-fb-zoom';
  pill.innerHTML =
    '<button type="button" class="pdp-fb-zoom__btn" data-zoom="in" aria-label="Zoom in"><svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true"><circle cx="10.5" cy="10.5" r="6.5"/><path d="M15.5 15.5L21 21M7.5 10.5h6M10.5 7.5v6"/></svg></button>' +
    '<button type="button" class="pdp-fb-zoom__btn" data-zoom="out" aria-label="Zoom out"><svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true"><circle cx="10.5" cy="10.5" r="6.5"/><path d="M15.5 15.5L21 21M7.5 10.5h6"/></svg></button>' +
    '<span class="pdp-fb-zoom__level">100%</span>';
  container.appendChild(pill);

  function panzoom() {
    var slide = fancybox.getSlide && fancybox.getSlide();
    return slide && slide.panzoom;
  }

  pill.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-zoom]');
    var pz = panzoom();
    if (!btn || !pz) return;
    var action = btn.getAttribute('data-zoom') === 'in' ? 'zoomIn' : 'zoomOut';
    if (typeof pz[action] === 'function') pz[action]();
    else if (typeof pz.execute === 'function') pz.execute(action);
  });

  var level = pill.querySelector('.pdp-fb-zoom__level');
  if (window.__pdpZoomTimer) clearInterval(window.__pdpZoomTimer);
  window.__pdpZoomTimer = setInterval(function () {
    // Fancybox 5: the zoom of the picture on screen is the scale of its Panzoom (1 = the picture fitted to the screen)
    var pz = panzoom();
    var scale = pz && typeof pz.scale === 'number' ? pz.scale : 1;
    level.textContent = Math.round((scale || 1) * 100) + '%';
  }, 150);
}
